import { get } from 'lodash';

const getColorToken = (color, colorSet) => ({ theme }) => {
    return getColorTokenVanilla(theme, color, colorSet);
};
const getColorTokenVanilla = (theme, color, colorSet) => {
    return get(theme, `colors.${colorSet}.${color}`);
};

export { getColorToken, getColorTokenVanilla };
//# sourceMappingURL=getColorToken.js.map
